<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('jobs')" :is-filter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('jobs')" :is-filter="false">
                </HeaderMobile>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div class="col-12">
                                <ValidationProvider name="job" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('process')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                            :validate-error="errors[0]" :options="jobOptions"
                                            v-model="form.job"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4" v-if="showSemester">
                                        <ValidationProvider name="semester_id" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('semester')">
                                                <semesters-selectbox :multiple="false" :validate-error="errors[0]"
                                                    :setActive="true" v-model="form.semester_id">
                                                </semesters-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4"
                                        v-if="['job_prep_student_period_status_create'].includes(form.job)">
                                        <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                            <b-form-group :label="$t('academic_year')">
                                                <academic-years-selectbox :validate-error="errors[0]"
                                                    v-model="form.academic_year" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-12 col-sm-4 col-md-4 col-lg-4"
                                        v-if="['job_prep_student_period_status_create'].includes(form.job)">
                                        <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                            <b-form-group :label="$t('module')">
                                                <module-selectbox valueType="id" :academic_year="form.academic_year"
                                                    :validate-error="errors[0]" v-model="form.module_id" />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['bulk_registration_ebys_download'].includes(form.job)">
                                <ValidationProvider name="document_numbers" :rules="['bulk_registration_ebys_download'].includes(form.job) ? 'required' : ''" v-slot="{ errors }">
                                    <b-form-group :label="$t('document_type')">
                                        <ParameterSelectbox code="ebys_document_types" v-model="document_numbers" :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12" v-if="showNumbers">
                                <ValidationProvider name="number" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_numbers')">
                                        <lined-textarea v-model="form.number" :nowrap="false" :disabled="false"
                                            :styles="{ height: '15em', resize: 'both' }" :validateError="errors[0]">
                                        </lined-textarea>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>


                            <div class="col-12 col-md-6"
                                v-if="['auto_course_registration', 'auto_irregular_course_registration', 'auto_repeat_course_registration', 'max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="faculty_code" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('faculty')">
                                            <faculty-selectbox v-model="faculty_code" :validate-error="errors[0]" />
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>
                            <div class="col-12 col-md-6"
                                v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="department_code" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('department')">
                                        <department-selectbox v-model="department_code" :multiple="true"
                                                              :faculty_code="faculty_code" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="program_code" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('program')">
                                        <program-selectbox v-model="program_code" :faculty_code="faculty_code"
                                                           :department_code="department_code" :multiple="true" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="advisor_id" rules="" v-slot="{ errors}">
                                    <b-form-group :label="$t('advisor')">
                                        <staff-auto-suggest v-model="advisor_id" :validate-error="errors[0]" open-direction="top"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                 v-if="['max_duration_information_for_advisor',
                                  'assign_doesnt_have_payment_approval', 'assign_doesnt_have_course_registration'].includes(form.job)">
                                <ValidationProvider name="program_level" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('level')">
                                        <parameter-selectbox v-model="program_level" :multiple="true"
                                                             :validate-error="errors[0]" code="program_levels"></parameter-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                 v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="registration_type" rules="" v-slot="{valid, errors}">
                                  <b-form-group :label="$t('registration_type_1')">
                                    <parameter-selectbox v-model="registration_type"
                                                         code="registration_types"></parameter-selectbox>
                                  </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                 v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="student_group" rules="" v-slot="{valid, errors}">
                                  <b-form-group :label="$t('student_group')">
                                    <multi-selectbox
                                        :multiple="false"
                                        :options="[{value:'TR', text:$t('variable_language')}, {value:'YU', text:'YU'}]"
                                        :validate-error="errors[0]"
                                        v-model="student_group">
                                    </multi-selectbox>
                                  </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6"
                                 v-if="['auto_course_registration', 'max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="class" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('class')">
                                            <parameter-selectbox code="classes" v-model="form.class"></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['auto_course_registration'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="course_type" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('course_type')">
                                            <parameter-selectbox code="course_types" v-model="form.course_type"></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['osym_score_inquiry_with_national_ids'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="exam_type" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('exam_type')">
                                            <parameter-selectbox code="osym_exam_types" v-model="form.exam_type"></parameter-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['osym_score_inquiry_with_national_ids'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="year" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('year')">
                                            <years-selectbox :up="false" v-model="form.year"></years-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['update_summer_school_paid_status'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="delete_unpaid_courses" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('delete_unpaid_courses')">
                                            <b-checkbox v-model="form.delete_unpaid_courses" value="1"></b-checkbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>


                            <div class="col-12 col-md-6"
                                v-if="['auto_course_registration', 'auto_irregular_course_registration', 'auto_repeat_course_registration', 'job_prep_student_period_status_create', 'bulk_address_update', 'registrations_bulk_delete','osym_score_inquiry', 'ois_student_transfer', 'calculate_number_of_semesters'].includes(form.job)">
                                <ValidationProvider name="student_numbers" :rules="['ois_student_transfer'].includes(form.job) ? 'required' : ''" v-slot="{ errors }">
                                    <b-form-group :label="$t('student_numbers')">
                                        <lined-textarea v-model="student_numbers" :nowrap="false" :disabled="false"
                                            :styles="{ height: '124px' }" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>


                            <div class="col-12 col-md-6"
                                 v-if="['ois_student_course_transfer', 'calculate_number_of_semesters'].includes(form.job)">
                                <ValidationProvider name="student_program_id" :rules="['ois_student_course_transfer'].includes(form.job) ? 'required' : ''" v-slot="{ errors }">
                                    <b-form-group :label="$t('student_program_id')">
                                        <lined-textarea v-model="student_program_id" :nowrap="false" :disabled="false"
                                                        :styles="{ height: '124px' }" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['osym_score_inquiry_with_national_ids'].includes(form.job)">
                                <ValidationProvider name="national_ids" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('national_ids')">
                                        <lined-textarea v-model="national_ids" :nowrap="false" :disabled="false"
                                                        :styles="{ height: '124px' }" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['copy_scholarships','copy_graduate_scholarships'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="from_period_id" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('from_period')">
                                            <payment-periods-selectbox v-model="form.from_period_id"></payment-periods-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['copy_scholarships','copy_graduate_scholarships'].includes(form.job)">
                                <ValidationObserver>
                                    <ValidationProvider name="to_period_id" rules="" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('to_period')">
                                            <payment-periods-selectbox v-model="form.to_period_id"></payment-periods-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </ValidationObserver>
                            </div>

                            <div class="col-12 col-md-6"
                                 v-if="['max_duration_information_for_advisor'].includes(form.job)">
                                <ValidationProvider name="send_to_secretaries" rules="" v-slot="{ errors }">
                                    <b-form-group :label="$t('send_to_secretaries')">
                                        <yes-no-selectbox v-model="form.send_to_secretaries" :validateError="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mb-4" v-if="['bulk_student_transfer'].includes(form.job)">
                                <import-form />
                            </div>
                            <div class="col-12 mb-4" v-if="['edit_class_information'].includes(form.job)">
                                <student-edit-import />
                            </div>
                            <div class="col-12 mb-4" v-if="['bulk_translation'].includes(form.job)">
                                <bulk-translation-import />
                            </div>
                            <div class="col-12 mb-4"
                                v-if="['student_programs_graduation_requirement'].includes(form.job)">
                                <student-programs-graduation-requirement />
                            </div>
                            <div class="col-12 mb-4" v-if="['scholarships_import'].includes(form.job)">
                                <scholarships-import />
                            </div>
                            <div class="col-12 mb-4" v-if="['registrations_page_bulk_student_transfer'].includes(form.job)">
                                <RegistrationsBulkStudenTransfer />
                            </div>
                            <div class="col-12 mb-4" v-if="['bulk_section_update'].includes(form.job)">
                                <BulkSectionUpdate />
                            </div>
                            <div class="col-6 mb-4" v-if="['search_kps_by_staff_national_id'].includes(form.job)">
                                <ValidationProvider name="national_ids" :rules="['search_kps_by_staff_national_id'].includes(form.job) ? 'required' : ''" v-slot="{ errors }">
                                    <b-form-group :label="$t('staff_tc')">
                                        <lined-textarea v-model="national_ids" :nowrap="false" :disabled="false"
                                                        :styles="{ height: '124px' }" :validate-error="errors[0]" />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>



                            <div class="col-12">
                                <b-button @click="start" label="start_process"
                                    v-show="!['scholarships_import', 'bulk_student_transfer', 'edit_class_information', 'bulk_translation', 'student_programs_graduation_requirement','registrations_page_bulk_student_transfer','bulk_section_update'].includes(form.job)"></b-button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>

        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import { ValidationObserver, ValidationProvider } from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import JobService from "@/services/JobService";
import LinedTextarea from "../../../components/elements/LinedTextarea"
import SemestersSelectbox from "../../../components/interactive-fields/SemestersSelectbox"
import qs from "qs"
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox"
import ModuleSelectbox from "@/components/interactive-fields/ModuleSelectbox"
import ImportForm from "@/modules/jobs/pages/import/importForm.vue";
import studentEditImport from "@/modules/jobs/pages/import/studentEditImport";
import BulkTranslationImport from "@/modules/jobs/pages/import/bulkTranslationImport.vue";
import StudentProgramsGraduationRequirement from "@/modules/jobs/pages/import/studentProgramsGraduationRequirement.vue";
import ScholarshipsImport from "@/modules/jobs/pages/import/scholarshipsImport.vue";
import RegistrationsBulkStudenTransfer from "@/modules/jobs/pages/import/registrationsBulkStudenTransfer.vue";
import StaffAutoSuggest from "@/components/interactive-fields/StaffAutoSuggest.vue";
import YearsSelectbox from "@/components/interactive-fields/YearsSelectbox.vue";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox.vue";
import BulkSectionUpdate from "@/modules/jobs/pages/import/bulkSectionUpdate.vue";

export default {
    name: "JobsStart",
    components: {
        BulkSectionUpdate,
        PaymentPeriodsSelectbox,
        YearsSelectbox,
        StudentProgramsGraduationRequirement,
        BulkTranslationImport,
        ImportForm,
        SemestersSelectbox,
        LinedTextarea,
        MultiSelectbox,
        AppLayout,
        ValidationProvider,
        ValidationObserver,
        Header,
        HeaderMobile,
        AcademicYearsSelectbox,
        ModuleSelectbox,
        studentEditImport,
        ScholarshipsImport,
        RegistrationsBulkStudenTransfer,
        StaffAutoSuggest,
    },
    metaInfo() {
        return {
            title: this.$t('jobs')
        }
    },
    data() {
        return {
            document_numbers:[],
            showSemester: false,
            showNumbers: false,
            faculty_code: null,
            department_code: null,
            program_code: null,
            advisor_id: null,
            program_level: null,
            registration_type: null,
            student_group: null,
            student_numbers: null,
            student_program_id: null,
            national_ids: null,
            isFile: null,
            form: {},
            jobOptions: [
                { value: 'calculate_extra_graduate_courses', text: this.$t('calculate_extra_graduate_courses') },
                { value: 'auto_course_registration', text: this.$t('auto_course_registration') },
                { value: 'auto_repeat_course_registration', text: this.$t('auto_repeat_course_registration') },
                { value: 'auto_irregular_course_registration', text: this.$t('auto_irregular_course_registration') },
                { value: 'create_student_semesters', text: this.$t('create_student_semesters') },
                { value: 'assign_doesnt_have_payment_approval', text: this.$t('assign_doesnt_have_payment_approval') },
                {
                    value: 'assign_doesnt_have_course_registration',
                    text: this.$t('assign_doesnt_have_course_registration')
                },
                {
                    value: 'delete_empty_summer_student_semester',
                    text: this.$t('delete_empty_summer_student_semester')
                },
                {
                    value: 'job_prep_student_period_status_create',
                    text: this.$t('job_prep_student_period_status_create')
                },
                { value: 'bulk_address_update', text: this.$t('bulk_address_update') },
                {
                    value: 'foreign_student_community_internship_assignment',
                    text: this.$t('foreign_student_community_internship_assignment')
                },
                {
                    value: 'registrations_bulk_delete',
                    text: this.$t('registrations_bulk_delete')
                },
                {
                    value: 'course_drop_process',
                    text: this.$t('course_drop_process')
                },
                {
                    value: 'bulk_student_transfer',
                    text: this.$t('bulk_student_transfer')
                },
                {
                    value: 'edit_class_information',
                    text: this.$t('edit_class_information')
                },
                {
                    value: 'bulk_translation',
                    text: this.$t('bulk_translation')
                },
                {
                    value: 'update_summer_school_paid_status',
                    text: this.$t('update_summer_school_paid_status')
                },
                {
                    value: 'student_programs_graduation_requirement',
                    text: this.$t('student_programs_graduation_requirement')
                },
                {
                    value: 'section_for_repeats',
                    text: this.$t('section_for_repeats')
                },
                {
                    value: 'scholarships_import',
                    text: this.$t('scholarships_import')
                },

                {
                    value: 'registrations_page_bulk_student_transfer',
                    text: this.$t('registrations_page_bulk_student_transfer')
                },
                { value: 'max_duration_information_for_advisor', text: this.$t('max_duration_information_for_advisor') },
                { value: 'search_kps_by_student_numbers', text: this.$t('search_kps_by_student_numbers') },
                { value: 'calculate_number_of_semesters', text: this.$t('calculate_number_of_semesters') },
                {
                    value: 'osym_score_inquiry',
                    text: this.$t('OSYM_score_inquiry')
                },
                {
                    value: 'osym_score_inquiry_with_national_ids',
                    text: this.$t('OSYM_score_inquiry_with_national_ids')
                },
                {
                    value: 'preparatory_class_advancement_blocking',
                    text: this.$t('preparatory_class_advancement_blocking')
                },
                {
                    value: 'update_acceptance_letters',
                    text: this.$t('update_acceptance_letters')
                },
                {
                    value: 'copy_scholarships',
                    text: this.$t('copy_l_ol_scholarships')
                },
                {
                    value: 'copy_graduate_scholarships',
                    text: this.$t('copy_graduate_scholarships')
                },
                {
                    value: 'ois_student_transfer',
                    text: this.$t('ois_student_transfer')
                },
                {
                    value: 'ois_student_course_transfer',
                    text: this.$t('ois_student_course_transfer')
                },
                {
                    value: 'search_kps_by_staff_national_id',
                    text: this.$t('search_kps_by_staff_national_id')
                },
                {
                    value: 'bulk_registration_ebys_download',
                    text: this.$t('bulk_registration_ebys_download')
                },
                {
                    value: 'migrate_to_undergraduate_student_data',
                    text: this.$t('migrate_to_undergraduate_student_data')
                },
                {
                    value: 'delete_student_over_semesters_after_leaving_students',
                    text: this.$t('delete_student_over_semesters_after_leaving_students')
                },
                {
                    value: 'set_passive_without_any_student_course_sections',
                    text: this.$t('set_passive_without_any_student_course_sections')
                },
                {
                    value:'transfer_toles_applications',
                    text:this.$t('transfer_toles_applications'),
                },
                {
                    value:'bulk_section_update',
                    text:this.$t('bulk_section_update'),
                }
            ],
            formProcess: null,
        }
    },
    methods: {
        formClear() {
            this.formProcess = null
        },
        async start() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                let config = { params: this.form };
                let oldNumber = this.form.number;
                if (oldNumber) {
                    config.params.number = config.params.number.split(/\n/);
                    this.student_numbers=oldNumber;
                }

                this.$swal.fire({
                    text: this.$t('are_you_sure_to_start_process'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            if (this.form.job == 'calculate_extra_graduate_courses') {
                                JobService.calculateExtraGraduateCourses().then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'auto_course_registration') {
                                const config = {
                                    params: {
                                        faculty_code: this.faculty_code,
                                        class: this.form.class,
                                        course_type: this.form.course_type,
                                        student_number: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.autoCourseRegistration(config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'auto_repeat_course_registration') {
                                const config = {
                                    params: {
                                        faculty_code: this.faculty_code,
                                        student_number: this.student_numbers != null ? this.student_numbers.replace(/\n/g, ',') : null
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.autoRepeatCourseRegistration(config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'auto_irregular_course_registration') {
                                const config = {
                                    params: {
                                        faculty_code: this.faculty_code,
                                        student_number: this.student_numbers != null ? this.student_numbers.replace(/\n/g, ',') : null
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.autoIrregularCourseRegistration(config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'create_student_semesters') {
                                JobService.createStudentSemesters(this.form.semester_id).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'assign_doesnt_have_payment_approval') {
                                const config = {
                                    params: {
                                        program_level: this.program_level
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.assignDoesntHavePaymentApproval(this.form.semester_id, config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'assign_doesnt_have_course_registration') {
                                const config = {
                                    params: {
                                        program_level: this.program_level
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.assignDoesntHaveCourseRegistration(this.form.semester_id, config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            }
                            else if (this.form.job == 'delete_empty_summer_student_semester') {
                                JobService.deleteEmptySummerStudentSemester(this.form.semester_id).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            }
                            else if (this.form.job == 'job_prep_student_period_status_create') {
                                let formData = {
                                    module_id: this.form.module_id,
                                    student_number: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }

                                JobService.prepStudentsSemesterStatusUpdate(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job == 'bulk_address_update') {
                                let formData = {
                                    student_numbers: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.bulkAddressUpdate(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job == 'foreign_student_community_internship_assignment') {
                                let formData = {
                                    student_numbers: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.foreignStudentCommunityInternshipAssignment(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job == 'registrations_bulk_delete') {
                                let formData = {
                                    student_number: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.registrationsBulkDelete(formData).then(response => {
                                    this._downloadFile(response, 'registrations_bulk_delete.xlsx')
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'course_drop_process') {
                                JobService.courseDropCommand().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'edit_class_information') {
                                JobService.studentExcelImport().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'update_summer_school_paid_status') {
                                JobService.updateSummerSchoolPaidStatus(this.form).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'student_programs_graduation_requirement') {
                                JobService.studentProgramsGraduationRequirement().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job == 'section_for_repeats') {
                                JobService.createSectionForRepeats().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'calculate_number_of_semesters') {
                                const config = {
                                    params: {
                                        student_number: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(','),
                                        student_program_id: this.student_program_id == null ? null : this.student_program_id.replace(/\n/g, ',').split(',')
                                    },
                                    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.calculateNumberOfSemesters(config).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'max_duration_information_for_advisor') {
                                const config = {
                                  params: {
                                    filter: {
                                        faculty_code: this.faculty_code,
                                        class: this.form.class,
                                        department_code: this.department_code,
                                        program_code: this.program_code,
                                        advisor_id: this.advisor_id,
                                        program_level: this.program_level,
                                        registration_type: this.registration_type,
                                        student_group: this.student_group,
                                        send_to_secretaries: this.form.send_to_secretaries === 'E' ? 1 : 0,
                                    }
                                  },
                                  paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                };
                                JobService.updateMaxDurationInformationStart(config).then(this.callback).catch(e => {
                                  this.showErrors(e, this.$refs.form);
                                });
                            }else if (this.form.job == 'search_kps_by_student_numbers') {
                                let formData = {
                                    student_numbers: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.findPersonFromKpsByStudentNumbers(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job ==='osym_score_inquiry'){
                                let formData = {
                                    student_program_ids: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.osymScoreInquiry(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job ==='osym_score_inquiry_with_national_ids'){
                                let formData = {
                                    national_ids: this.national_ids == null ? null : this.national_ids.split(/\n/),
                                    year: this.form.year,
                                    exam_type: this.form.exam_type
                                }
                                JobService.queryOsymPoints(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'preparatory_class_advancement_blocking') {
                                JobService.preparatoryClassAdvancementBlocking().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job === 'update_acceptance_letters') {
                                JobService.updateAcceptanceLetters().then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'copy_scholarships') {
                                let formData = {
                                    from_period_id: this.form.from_period_id,
                                    to_period_id: this.form.to_period_id
                                }
                                JobService.copyScholarships(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'copy_graduate_scholarships') {
                                let formData = {
                                    from_period_id: this.form.from_period_id,
                                    to_period_id: this.form.to_period_id
                                }
                                JobService.copyGraduateScholarships(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'ois_student_transfer') {
                                let formData = {
                                    student_number: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.oisStudentTransfer(formData).then(response => {
                                    this.$toast.success(this.$t('success'))
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }
                            else if (this.form.job == 'ois_student_course_transfer') {
                                let formData = {
                                    student_program_id: this.student_program_id == null ? null : this.student_program_id.replace(/\n/g, ',').split(',')
                                }
                                JobService.oisStudentCourseTransfer(formData).then(response => {
                                    this.$toast.success(this.$t('success'))
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }else if (this.form.job == 'search_kps_by_staff_national_id') {
                                let formData = {
                                    national_ids: this.national_ids == null ? null : this.national_ids.split(/\n/),
                                }
                                JobService.searchKpssByStaffNationalId(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }else if (this.form.job == 'bulk_registration_ebys_download') {
                                let formData = {
                                    student_numbers: this.student_numbers == null ? null : this.student_numbers.replace(/\n/g, ',').split(','),
                                    document_numbers:this.document_numbers == null ? null : this.document_numbers.replace(/\n/g, ',').split(',')
                                }
                                JobService.bulkRegistrationsDocumentDownload(formData).then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }else if (this.form.job == 'migrate_to_undergraduate_student_data') {
                                JobService.migrateUndergraduateStudentData().then(response => {
                                    this.callback(response)
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            }else if(this.form.job === 'transfer_toles_applications'){
                                JobService.transferTolesApplication().then(response => {
                                    this.$toast.success(this.$t('proccess_success'));
                                }).catch(e => {
                                    this.showErrors(e, this.$refs.form)
                                })
                            } else if (this.form.job == 'delete_student_over_semesters_after_leaving_students') {
                                let config = {}
                                if(this.student_numbers != null){
                                    config = {
                                        params: {
                                            filter:{
                                                student_number: this.student_numbers.replace(/\n/g, ',').split(',')
                                            }
                                        },
                                        paramsSerializer: (params) => qs.stringify(params, { encode: false }),
                                    }
                                    this.student_numbers = null
                                } else {
                                    config = ''
                                }
                                JobService.deleteStudentOversemestersAfterLeavingStudents(config).then(this.callback).catch(e => {
                                    this.showErrors(e, this.$refs.form);
                                });
                            } else if (this.form.job == 'set_passive_without_any_student_course_sections') {
                                if(this.checkPermission('section_setpassivewithoutanystudentcoursesections')) {
                                    JobService.setPassiveCourseSections().then(response => {
                                        this.$toast.success(this.$t('success'))
                                    }).catch(e => {
                                        this.showErrors(e, this.$refs.form)
                                    })
                                } else {
                                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                                }
                            }
                            this.faculty_code = null
                            this.form.number = oldNumber
                        }
                    })
            }
        },
        callback(response) {
            if (response.data.data.log_id) {
                this.$toast.success(this.$t(response.data.message));
                this.$router.push('/job/logs/detail/' + response.data.data.log_id)
            } else if (response.data.data.job_id) {
                if (response.data.message) {
                    this.$toast.success(this.$t(response.data.message));
                } else {
                    this.$toast.success(this.$t('proccess_success'));
                }

                this.$router.push('/job/logs/detail/' + response.data.data.job_id)
            }
        },
        clickFile() {
            this.formProcess = 'import'
            this.$refs.importFormModal.$refs.commonModal.show()
        }
    },
    watch: {
        'form.job'(newVal) {
            this.showSemester = false;
            this.showNumbers = false;

            if (newVal == 'create_student_semesters') {
                this.showSemester = true;
            } else if (newVal == 'assign_doesnt_have_payment_approval') {
                this.showSemester = true;
            } else if (newVal == 'assign_doesnt_have_course_registration') {
                this.showSemester = true;
            }
            else if (newVal == 'delete_empty_summer_student_semester') {
                this.showSemester = true;
            }
            else if (newVal == 'bulk_student_transfer') {
                this.isFile = true
            }
            else if (newVal == 'search_kps_by_student_numbers') {
                this.showNumbers = true
            }else if (newVal === 'bulk_registration_ebys_download') {
                this.showNumbers = true
            } else if(newVal == 'delete_student_over_semesters_after_leaving_students') {
                this.showNumbers = true
            }

        }
    }
};
</script>
